import React from 'react';
import moment from 'moment';
import ModalWrapper from '../../helpers/modalWrapper';
import { SIZE_LG, MOMENT_DATE_TIME_FORMAT } from '../../helpers/constants';
import CONTENT_STRINGS from '../../helpers/contentStrings';
import StagedStep4 from './WizardSteps/stagedStep4';
import { amountColumnsDisplayDataPerStage } from '../../helpers/functions';

const ApplicationStagedPremiumSettingsRevisionsModal = (props) => {
    const {
        isOpen,
        onClose,
        revision,
        revisionIndex,
        highlightedFields,
    } = props;

    if (!revision) return null;

    const { createdDate, revisionDate, applicationStagedPremiumSubSettingDtos = [] } = revision;

    return (
        <ModalWrapper
            isOpen={isOpen}
            onClose={onClose}
            size={SIZE_LG}
            title={`${CONTENT_STRINGS.PREVIOUS_APPLICATION_PREMIUM_SETTING} — ${moment(revisionDate ?? createdDate).format(MOMENT_DATE_TIME_FORMAT)}`}
            modalTestId={'staged-premium-history-modal'}
            buttonTestId={'close-modal'}
        >
            <StagedStep4
                amountColumnsDisplayDataPerStage={amountColumnsDisplayDataPerStage}
                isApplicationPremium={true}
                stagesSubSettings={applicationStagedPremiumSubSettingDtos}
                stagedPremiumData={revision}
                notesTestId={`staged-premium-notes-history-${revisionIndex}`}
                commentsTestId={`staged-premium-comments-history-${revisionIndex}`}
                coverageTestId={`staged-premium-coverage-history-${revisionIndex}`}
                deductiblesTestId={`staged-premium-deductible-history-${revisionIndex}`}
                endorsementsTestId={`staged-premium-endorsement-history-${revisionIndex}`}
                averageExpectedPremiumTestId={`staged-premium-average-expected-premium-history-${revisionIndex}`}
                highlightedFields={highlightedFields}
                isStagedApplicationRevisionsModalOpen={isOpen}
                revisionIndex={revisionIndex}
            />
        </ModalWrapper>
    );
};

export default ApplicationStagedPremiumSettingsRevisionsModal;
